import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-statics-item__head" }
const _hoisted_2 = { class: "as-title" }
const _hoisted_3 = { class: "as-statics-item__content" }


const __default__ = {};

interface Props {
        classModify?: string;
        mainValue: number | string;
        subValue?: number | string;
        title: string;
        subTitle?: string | number;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StaticsItem',
  props: {
    classModify: { default: 'as-orange' },
    mainValue: { default: 0 },
    subValue: { default: 0 },
    title: { default: '' },
    subTitle: { default: 'Trung bình giải đấu' }
  },
  setup(__props: any) {

    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-statics-item ${_ctx.classModify}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.mainValue) + "%", 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.subTitle) + _toDisplayString(`${_ctx.subValue ? `: ${_ctx.subValue}%`: ''}`), 1)
  ], 2))
}
}

})